import React, { useEffect, useRef, useState, setState, Fragment } from 'react';
import '../../../styles/mainContents.css';
import { setReturnsState, setNoReturnsNeededCbState, fetchInventoryDetailPartnos, setNoRotatesNeededCbState, setCorePickupState, fetchRotatesInvno, setRotateRequestState, clearInvnoConfirmationStatus, fetchCustomerDetailReset, fetchSubmitInvnoConfirmation, fetchCustnoDetail, setRowsDataSelectedIndexState, fetchInvoicesPrintRecordPrinted, fetchInvoicesPrintDetailReset, fetchInvoicesPrintDetail, fetchInvoices } from '../../../redux/actions/PostActions';
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { Tooltip, IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Print } from '@mui/icons-material'
import { superSearch } from '@codewell/super-search';
import EmptyMuiDataTable from '../../layout/EmptyMuiDataTable';
import fmplogo from '../../../assets/FMP-Icon.png';
import moment from "moment";
import ReactToPrint, { useReactToPrint }  from 'react-to-print';
import InvoicesPrintPage from './PrintPages/InvoicesPrintPage';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useCallback } from 'react';
import RotateRequestTable from '../../shared/RotateRequestTable';
import RotatesTable from '../../shared/RotatesTable';
import ReturnsTable from '../../shared/ReturnsTable'; 

function Invoices(props) {

  const { dispatchSetReturnsState, dispatchSetNoReturnsNeededCbState, noReturnsNeededCbState, fetch_InventoryDetailPartnos, noRotatesNeededCbState, dispatchSetNoRotatesNeededCbState, dispatchSetCorePickupState, fetch_rotatesInvno, rotatesState, dispatchSetRotateRequestState, invoiceNoticeMessageState, dispatch_clearInvnoConfirmationStatus, invoiceErrorMessageState, printConfirmationResponseState, fetch_customerDetailReset, fetch_submitInvnoConfirmation, fetch_custnoDetail, corePickupState, custnoDetailState, custServerResponseState, dispatch_setRowsDataSelectedIndexState, rowsDataSelectedIndexState, invoicesProcessingPrintedStatus, fetch_InvoicesPrintRecordPrinted, fetch_InvoicesPrintDetailReset, invoicesPrintDetailState, fetch_InvoicesPrintDetail, invoicesState, fetch_invoices, authreducerState } = props;

  const today = new Date().toLocaleDateString('en-CA');

  let [selectedInvnosState, setSelectedInvnosState] = useState([])
  let [clickedInvnoState, setClickedInvnoState] = useState([])

  let [isDialogOpen, setIsDialogOpen] = useState(false)

  const [printBtnClickedState, setPrintBtnClickedState] = useState(false)
  
  let [invnoDeliveryDateState, setInvnoDeliveryDateState] = useState(today)

  const componentRef = useRef();
  

  useEffect( () => {
    fetch_invoices(authreducerState.user) 
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {

      if( authreducerState.user.role_name !== undefined && (authreducerState.user.role_name === 'ADMIN' || authreducerState.user.role_name === 'EDITOR')) {
        if (window.confirm('Please click "OK" if you had printed for record keeping purposes.')) {

          if(clickedInvnoState !== undefined && clickedInvnoState !== null && Object.keys(clickedInvnoState).length > 0){
            
            fetch_InvoicesPrintRecordPrinted(authreducerState.user, clickedInvnoState.INVNO)
            setClickedInvnoState(null)   
            // fetch_invoices(authreducerState.user)                          
          }
          else{
            console.log('called selectedInvnosState', selectedInvnosState)
  
            fetch_InvoicesPrintRecordPrinted(authreducerState.user, selectedInvnosState)
            // fetch_invoices(authreducerState.user)       
          }
          
          //TODO --- direct link /invoices not working -- hitting invoice menu to refresh page (currently only using history)
  
          //TODO: refresh status of invoices table --- to show print
          //console.log('Invoices invoicesProcessingPrintedStatus',invoicesProcessingPrintedStatus)
          // fetch_invoices(authreducerState.user) 
        } 
      } 
         
   
    }
  });

  useEffect( () => {
    if( invoicesPrintDetailState !== undefined && Object.keys(invoicesPrintDetailState).length > 0 ){
      setPrintBtnClickedState(true);      
    }       
  }, [invoicesPrintDetailState]);

  useEffect( () => {
    if( printBtnClickedState !== undefined && printBtnClickedState === true ){
      handlePrint()
      setPrintBtnClickedState(false);

      // fetch_InvoicesPrintDetailReset();
    }       
  }, [printBtnClickedState, handlePrint]);
  


  const columnsInvoices = [    
    {
      name: "INVNO",
      label: "Invoice#",
      options: {
        filter: false,
        sort: true, 
        sortThirdClickReset: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
        }}), 
        customBodyRender: (value, rowInfo) => {
          
          let clickedIndex = rowInfo.currentTableData[rowInfo.rowIndex].index

          return (
            <>
              <input type='button' onClick={ () => { 
                    
                fetch_InvoicesPrintDetail(invoicesState[clickedIndex].INVNO);

                if(invoicesState[clickedIndex].ROTATE_REQUEST === -1){
                  fetch_rotatesInvno(invoicesState[clickedIndex].INVNO)
                  
                } 

                setClickedInvnoState(invoicesState[clickedIndex])
                } } value={value} />
            </>
          )
        },                    
      },
    },
    {
      name: "INVOICE_DATE",
      label: "Invoice Date",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"45px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
        }}),
        customBodyRender: value => {
          return value !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
        },
      },
    },        
    {
      name: "ORDERNO",
      label: "Pickticket",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true, 
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
        }}),             
      },
    },
    {
      name: "ORDER_DATE",
      label: "Order Date",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"45px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
        }}),
        customBodyRender: value => {
          return value !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
        },
      },
    },
    {
      name: "LOC",
      label: "Loc",
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"55px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
        }}),
      },
    },    
    {
      name: "CUSTNO",
      label: "Cust#",
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"55px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
        }}),
      },
    },
    {
      name: "CUSTNAME",
      label: "Cust name",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true,        
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "2px 4px 0px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"125px", 
          wordWrap: "break-word",
          padding: "14px 10px 14px 16px",         
          fontSize: ".875em", 
        }}),
      },
    },
    {
      name: "SHIP_TO_CITY",
      label: "Ship To City",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true,        
        setCellHeaderProps: () => ( {style: {
          maxWidth:"95px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),
      },
    },
    {
      name: "SHIP_TO_STATE",
      label: "Ship To State",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true,   
        setCellHeaderProps: () => ( {style: {
          maxWidth:"95px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"30px", 
          wordWrap: "normal",
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }}),
      },
    },
    {
      name: "CUST_PO",
      label: "Cust PO",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true,   
        setCellHeaderProps: () => ( {style: {
          maxWidth:"100px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }} 
        ),
      }
    },  
    {
      name: "PRINTED",
      label: "Printed",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"55px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
        }}),
      },
    },
    {
      name: "DELIVERY_CONFIRMED",
      label: "Delivery Confirmed",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"90px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"65px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
        }}),
        customBodyRender: (value, rowInfo) => {
          // console.log(value, rowInfo)
          let clickedIndex = rowInfo.currentTableData[rowInfo.rowIndex].index

          //date when we started to check for confirmation
          let confirmNeeded = moment(invoicesState[clickedIndex].INVOICE_DATE,'MM/DD/YYYY') > moment('11/05/2023','MM/DD/YYYY') ? true : false
          
          // console.log(invoicesState[clickedIndex].INVNO, invoicesState[clickedIndex].INVOICE_DATE, 'confirmNeeded: ' + confirmNeeded, 'value: ' + value, 'rowInfo.rowIndex: ' + rowInfo.rowIndex, rowInfo.currentTableData[rowInfo.rowIndex].index)
          return (
            <>
              {
              (authreducerState.user.role_name === undefined) ? "" :                    
              (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" 
              :                
              
              confirmNeeded === true ?
                value === undefined || value === null || value === '' ?
                  <> 
                    <input type='button' onClick={ () => {
                      // console.log('invoicesState[clickedIndex]', invoicesState[clickedIndex])
                      dispatchSetRotateRequestState([]);

                      fetch_custnoDetail(authreducerState.user, invoicesState[clickedIndex].CUSTID)                                   

                      if(invoicesState[clickedIndex].ROTATE_REQUEST === -1){
                        fetch_rotatesInvno(invoicesState[clickedIndex].INVNO)

                      }   

                      setClickedInvnoState(invoicesState[clickedIndex])
                      setIsDialogOpen(true)
                      dispatchSetNoRotatesNeededCbState(false);
                      
                      dispatchSetNoReturnsNeededCbState(false);
                      dispatchSetReturnsState([]); 
                      setInvnoDeliveryDateState(today);
                      
                      } } value={'Confirm'} />
                    
                  </>
                  :
                  value
                :
                ''
              }
            </>
          )
        },         
      },
    }, 
    {
      name: "TOTAL_CORES_PICKED_UP",
      label: "Total Cores Picked Up",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"55px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
        }}),
      },
    },                                  
  ]
      
  const optionInvoices = {
    filterType: "checkbox",
    selectableRows: "multiple",
    selectableRowsHeader: false,
    rowsSelected: rowsDataSelectedIndexState,
    

    onRowSelectionChange: (rowsSelectedData, allRows, rowsSelected) => {
      // console.log('onRowSelectionChange:', rowsSelectedData, allRows, rowsSelected);
      let invoicesSelectedList = allRows.map((item,index)=>{ return invoicesState[item.dataIndex]})
      let invnoSelectedList = invoicesSelectedList.map((item,index)=>{
          return item.INVNO
      })      
      // console.log('onRowSelectionChange invnoSelectedList:', JSON.stringify(invnoSelectedList));

      dispatch_setRowsDataSelectedIndexState(rowsSelected)

      setSelectedInvnosState(invnoSelectedList)
      // console.log('onRowSelectionChange rowsDataSelectedIndexState: ' + JSON.stringify(rowsDataSelectedIndexState));
    },    
    responsive: "standard",
    fixedHeader: true,
    download:false,
    print:false,
    search: true,
    searchOpen: true,
    //searchAlwaysOpen: true,
    searchPlaceholder: 'SEARCH INVOICES',

    onRowClick: (rowData, rowMeta) => {
    },  
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <>
        <ClearSelectedCheckboxButton selectedRows={selectedRows}/>
        <PrintButton/>
      </>
    ),
    searchProps: {
      autoFocus: true,
      onKeyUp:(e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {          
          var rowsCounter = 0;
          var orderno = null;
          invoicesState.reduce( (previousValue, currentValue, currentIndex, array) => {          
            if(rowsCounter > 1){
              return null;
            }

            if(superSearch()(e.target.value, {...currentValue}).numberOfMatches>0){
              orderno = currentValue['ORDERNO']
              rowsCounter++
            }

            return rowsCounter;
          }, 0)

          if(rowsCounter === 1){
          }
        }
      }
    }, 

    rowsPerPage: 10,   
  };


  let ConfirmDeliveryDialog = () => {    
    // console.log('Invoices ConfirmDeliveryDialog called')

    const [ returnsCommentState, setReturnsCommentState ] = useState({
      ORIGINALINVNO: '',
      ORIGINALTICKET: '',
      ORIGINALPO: '',                              
    }); 

    return (
      isDialogOpen === true && custnoDetailState !== undefined && custnoDetailState !== null ? 
        <>        
          {fetch_InventoryDetailPartnos(authreducerState.user, custnoDetailState.CUSTLOC)}

          <Dialog maxWidth={'3'} onClose={() => { setIsDialogOpen(false); setClickedInvnoState(null); fetch_customerDetailReset(); dispatchSetRotateRequestState([]); dispatchSetNoRotatesNeededCbState(false); dispatchSetNoReturnsNeededCbState(false); dispatchSetReturnsState([]); setInvnoDeliveryDateState(today); }} open={isDialogOpen}>
              
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={ {width:'100%'} } >
              <div style={ {fontWeight:'bold', textAlign:'left',minWidth:'100%', width: '800px', margin:'0', padding:'0'} }>Confirm Delivery for invno {clickedInvnoState.INVNO}</div>
              
              <div>     
                <span>{custnoDetailState['CUSTNO']} </span>
                <span style={{float:'right', paddingRight: '2em'}}>Delivery Date </span>
              </div>              
              
              {/* <br/> */}
              <div>
                <span>{custnoDetailState['CUSTNAME']} </span>
                <span style={{float:'right', paddingRight: '2em'}}>
                  <input 
                    type='date'
                    min={today} 
                    value={invnoDeliveryDateState}
                    key={'invnoDeliveryDate'}
                    onChange={(e) => {
                      setInvnoDeliveryDateState(e.target.value);
                    }}    
                  /> 
                </span>
              </div>
              
              {/* <br/> */}
              {custnoDetailState['CUSTCITY']}, {custnoDetailState['CUSTSTATE']}
            </DialogTitle>      
            <IconButton
              aria-label="close"
              onClick={() => { setIsDialogOpen(false); setClickedInvnoState(null); fetch_customerDetailReset(); dispatchSetRotateRequestState([]); dispatchSetNoRotatesNeededCbState(false); dispatchSetNoReturnsNeededCbState(false); dispatchSetReturnsState([]); setInvnoDeliveryDateState(today); }}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            
            <DialogContent dividers style={ {minWidth:'100%'} }>
              {/* {console.log('custnoDetailState', custnoDetailState)} */}
              {
                (authreducerState.user.role_name === undefined) ? "" :                    
                (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" 
                : 
                  custnoDetailState.USER_CUST_PERMISSIONID !== undefined &&
                  custnoDetailState.USER_CUST_PERMISSIONID <= 1 ? 
                    <div id='corePickupDivId'>
                      <div id='corePickUpPrompt'>
                      Enter Any Cores Picked Up for custno {custnoDetailState['CUSTNO']}
                      </div>
                      <table id='corePickupLocTbl'>
                        <thead>                                              
                        </thead>
                        <tbody>                    
                          <tr>
                            <td style={ {fontWeight:'bold', textAlign:'end'} }>Loc:</td>
                            <td>
                              {custnoDetailState['USER_HAS_MULTIPLE_LOCS'] !== undefined && custnoDetailState['USER_HAS_MULTIPLE_LOCS'] === true ?                                                    
                                <input
                                  id='iCorePickupLocCustomers'
                                  className={'userInputField corePickupLocCN'}
                                  type='number'
                                  maxLength='3'
                                  min='0'
                                  max='999'
                                  name='corePickupLoc'
                                  defaultValue={''}
                                  value={corePickupState['LOC'] }
                                  onInput={(e) => {
                                    var min = e.target.min
                                    var max = e.target.max
                                    var val = parseInt(e.target.value) || (min - 1); // if input char is not a number the value will be (min - 1) so first condition will be true
                                    if (val < min){
                                      corePickupState['LOC'] = min
                                      e.target.value = min
                                    }
                                    else if (val > max){
                                      corePickupState['LOC'] = max 
                                      e.target.value = max 
                                    }                       
                                    else {
                                      corePickupState['LOC'] = e.target.value   
                                    }

                                    //TODO: look into update state via redux
                                    // console.log('Invoices corePickupState WAS', corePickupState)
                                    // let updatedState = corePickupState;
                                    // updatedState['LOC'] = e.target.value;                    
                                    // dispatchSetCorePickupState(updatedState)
                                    // console.log('Invoices corePickupState NOW', corePickupState)
                                    

                                  }}                                  
                                />                                                        
                              :
                                <span>
                                {custnoDetailState['USERLOC_IF_SINGLELOC_FOR_CORES'] !== undefined && custnoDetailState['USERLOC_IF_SINGLELOC_FOR_CORES'] > 0 ?                                                                                                                                
                                  corePickupState['LOC'] = custnoDetailState['USERLOC_IF_SINGLELOC_FOR_CORES'] 
                                  :
                                  'Error. Please contact FMP personal for correction with user location.'
                                }                                      
                                </span>
                                
                              }
                            </td>
                          </tr>
                          <tr>
                            <td style={ {fontWeight:'bold', textAlign:'end'} }>Default Loc:</td>
                            <td>{custnoDetailState['CUSTLOC']} ({custnoDetailState['LOC_CITY']},{custnoDetailState['LOC_STATE']}) </td>
                          </tr>
                          <tr>
                            <td style={ {fontWeight:'bold', textAlign:'end'} }>Cust's City,State:</td>
                            <td>{custnoDetailState['CUSTCITY']},{custnoDetailState['CUSTSTATE']} </td>
                          </tr>                                
                        </tbody>
                      </table>  

                      <table id='corePickupCommentTblId'>
                          <thead></thead>
                          <tbody>
                              <tr>
                                <td>Customer PO/Comments</td>
                                <td>
                                  <input
                                    id='iCoreCustomerPoComments'
                                    className={'userInputField'}
                                    type='text'
                                    maxLength='100'
                                    name='corePickupCustomerPoComments'
                                    defaultValue={''}
                                    onInput={(e) => {
                                      corePickupState['CUSTOMER_PO_COMMENT'] = e.target.value    
                                    }}
                                  /> 
                                </td>
                              </tr>

                          </tbody>
                      </table>

                      <table id='corePickupTblId'>
                        {/* <caption>Cores Picked up</caption> */}
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Pickup Qty</th>                  
                          </tr>
                        </thead>
                        { 
                          <tbody>                    
                            <tr>
                              <td>
                                BCRSM-CORE (U1's, Small SLA's, Power Sport)                  
                              </td>  
                              <td>
                                <input 
                                  id='iCoreSmEaPickupQty_Cust'
                                  className={'userInputField'}
                                  type='number' 
                                  name='nCoreSmEaPickupQty_Cust' 
                                  min="0"       
                                  max="500"
                                  defaultValue={0} 
                                  value={corePickupState['CORE_SM_QTY'] }                  
                                  onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_SM_QTY']
                                    }
                                    else{
                                      corePickupState['CORE_SM_QTY'] = e.target.value   
                                    }                                        
                                  }
                                  }
                                />                      
                              </td>  
                            </tr>

                            <tr>
                              <td>
                                BCRMD-CORE (Auto/Marine <span style={ {textDecoration:'underline'} }>not</span> group 31)               
                              </td>
                              <td>
                                <input 
                                  id='iCoreMDPickupQty_Cust'
                                  className={'userInputField'}
                                  type='number' 
                                  name='nCoreMDPickupQty_Cust'                      
                                  min="0"       
                                  max="500"
                                  defaultValue={0} 
                                  value={corePickupState['CORE_MD_QTY'] }               
                                  onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key  
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_MD_QTY']
                                    }
                                    else{
                                      corePickupState['CORE_MD_QTY'] = e.target.value   
                                    }   
                                      
                                    }
                                  }
                                />                      
                              </td>                     
                            </tr>

                            <tr>
                              <td>
                                BCRLG-CORE (4D, 8D & <span style={ {textDecoration:'underline'} }>All</span> group 31)                 
                              </td>
                              <td>
                                <input 
                                  id='iCoreLGPickupQty_Cust'
                                  className={'userInputField'}
                                  type='number' 
                                  name='nCoreLGPickupQty_Cust'                      
                                  min="0"       
                                  max="500"
                                  defaultValue={0}  
                                  value={corePickupState['CORE_LG_QTY'] }                
                                  onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_LG_QTY']
                                    }
                                    else{
                                      corePickupState['CORE_LG_QTY'] = e.target.value   
                                    }
                                      
                                    }
                                  }
                                />                      
                              </td>                     
                            </tr>   

                            <tr>
                              <td>
                                BCRCOREGOLF-EA (Golf)                   
                              </td>  
                              <td>
                                <input 
                                  id='iCoreGolfPickupQty_Cust'
                                  className={'userInputField'}
                                  type='number' 
                                  name='nCoreGolfPickupQty_Cust'                      
                                  min="0"       
                                  max="500"
                                  defaultValue={0}  
                                  value={corePickupState['CORE_GOLF_QTY'] }                  
                                  onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key 
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_GOLF_QTY']
                                    }
                                    else{
                                      corePickupState['CORE_GOLF_QTY'] = e.target.value   
                                    }                                          
                                  }
                                  }
                                />                      
                              </td>  
                            </tr>                                                                                                           
                          </tbody>
                        }

                      </table>
                    </div>                        
                : 'No access to submit delivery for customer'
          
                    
              }           
            </DialogContent>
            
            <DialogContent dividers>
              {
                (authreducerState.user.role_name === undefined) ? "" :                    
                (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" 
                : 
                clickedInvnoState.ROTATE_REQUEST !== undefined && clickedInvnoState.ROTATE_REQUEST !== null && (clickedInvnoState.ROTATE_REQUEST === 0 || clickedInvnoState.ROTATE_REQUEST === '') ?
                  <div className='rotateRequestDiv'>
                    <div className='rotateRequestPrompt'>
                      <div style={{float:'left', padding:'0 32px 3px 0'}}>
                        Enter <span style={{textDecoration:'underline', fontWeight:'bold'}}>New Rotate Request</span> for custno {custnoDetailState['CUSTNO']}
                      </div>

                      <div className='rotateRequestPrompt' style={{float:'right'}}>
                        Shelves Checked: NO ROTATE NEEDED
                        <input 
                          id='iNoRotateNeededCb'
                          className={'userInputField'}
                          type='checkbox'
                          name='noRotateNeededCbName'                   
                          checked={noRotatesNeededCbState}
                          onChange={(e) => {
                            if(noRotatesNeededCbState === false){
                              dispatchSetNoRotatesNeededCbState(true);   
                            }
                            else{
                              dispatchSetNoRotatesNeededCbState(false);                                                          
                            }
                          }}
                        />                      
                      </div> 
                    </div> 

                    <div className='rotateRequestPrompt' style={{float:'left', padding:'0 0 6px 0'}}>
                      Note: rotate request tickets are generated each morning
                    </div> 
                    
                    { noRotatesNeededCbState===false && <RotateRequestTable custid={clickedInvnoState.CUSTID} custloc={custnoDetailState.CUSTLOC} /> }

                  </div> 
                :                      
                clickedInvnoState.ROTATE_REQUEST !== undefined && clickedInvnoState.ROTATE_REQUEST !== null && clickedInvnoState.ROTATE_REQUEST === -1 ?
                  <div id='rotatesDivId'>
                    <div id='rotatesPrompt'>
                      Enter Rotate Results for custno {custnoDetailState['CUSTNO']}
                    </div> 
                    <div id='rotatesPromptNote'>NOTE: All rotated batteries are to be placed on rotate return pallet</div>
                    { <RotatesTable /> }

                  </div>                  
                : ''
                    
              }           
            </DialogContent>

            <DialogContent dividers>
              {
                (authreducerState.user.role_name === undefined) ? "" :                    
                (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" 
                :                     
                <div className='returnsDiv'>
                  <div className='returnsPrompt'>
                    <div style={{float:'left', padding:'0 32px 3px 0'}}>
                      Enter <span style={{textDecoration:'underline', fontWeight:'bold'}}>New Returns </span>for custno {custnoDetailState['CUSTNO']}
                    </div>
                    
                    <div className='returnsPrompt' style={{float:'right'}}>
                      Shelves Checked: NO RETURNS NEEDED
                      <input 
                        id='iNoReturnsNeededCb'
                        className={'userInputField'}
                        type='checkbox'
                        key='keyNoReturnsNeededCb'
                        name='noReturnsNeededCbName'                   
                        checked={noReturnsNeededCbState}
                        onChange={(e) => {
                          if(noReturnsNeededCbState === false){
                            dispatchSetNoReturnsNeededCbState(true);   
                          }
                          else{
                            dispatchSetNoReturnsNeededCbState(false);                                                          
                          }
                        }}
                      />                      
                    </div>                       
                  </div> 

                  <div className='returnsPrompt' style={{float:'right', padding:'5px 0 6px 0', textAlign:'end'}}>
                    <div >
                      Original Invoice #
                      <input 
                        id='iOriginalInvoiceNo'
                        className={'userInputField'}
                        type='text'
                        name='originalInvoiceNoName' 
                        onInput={ e => {
                          setReturnsCommentState({...returnsCommentState, ORIGINALINVNO: e.target.value})
                        }}                           
                      /> 
                    </div>

                    <div >
                      Original Ticket #
                      <input 
                        id='iOriginalTicketNo'
                        className={'userInputField'}
                        type='text'
                        name='originalTicketNoName'  
                        onInput={ e => {
                          setReturnsCommentState({...returnsCommentState, ORIGINALTICKET: e.target.value})

                        }}  
                      />   
                    </div>  

                    <div >
                      Original PO #
                      <input 
                        id='iOriginalPo'
                        className={'userInputField'}
                        type='text'
                        name='originalPoName' 
                        onInput={ e => {
                          setReturnsCommentState({...returnsCommentState, ORIGINALPO: e.target.value})
                          
                        }}                                
                      />   
                    </div>                                                                        
                  </div> 

                  { noReturnsNeededCbState===false && <ReturnsTable custid={custnoDetailState.CUSTID} custloc={custnoDetailState.CUSTLOC} /> }

                </div>                
                    
              }           
            </DialogContent>

            <DialogActions>
              <Button onClick={(e) => 
                {   
                  let checkCorePickUpState = (corePickupState.hasOwnProperty('CORE_MD_QTY') || 
                  corePickupState.hasOwnProperty('CORE_SM_QTY') ||
                  corePickupState.hasOwnProperty('CORE_GOLF_QTY') ||
                  corePickupState.hasOwnProperty('CORE_LG_QTY')) 

                  if(checkCorePickUpState === false) 
                  {                        
                    if (window.confirm('Please proceed if there are no cores picked up for current invno or click cancel to enter cores.')) 
                    {                          
                      if (window.confirm('Click Ok to submit confirmation or Cancel to not submit confirmation.')) 
                      {
                        const noCorePickupState = {}
                        fetch_submitInvnoConfirmation(authreducerState.user, clickedInvnoState.INVNO,noCorePickupState, clickedInvnoState.CUSTID, returnsCommentState, invnoDeliveryDateState) 

                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        
                        // dispatch_setRowsDataSelectedIndexState([])
                        // fetch_invoices(authreducerState.user)     
                        // setIsDialogOpen(false);

                        if( (invoiceErrorMessageState !== undefined && invoiceErrorMessageState !== null && invoiceErrorMessageState.length > 0 ) || 
                          (printConfirmationResponseState !== undefined && printConfirmationResponseState !== null && printConfirmationResponseState.length > 0)){
                          dispatch_setRowsDataSelectedIndexState([])
                          fetch_invoices(authreducerState.user)     
                          setIsDialogOpen(false);
                        }

                      } 
                      else 
                      {
                        console.log('Cancelled - Submit delivery was not saved.');
                      }                            
                    }
                    else 
                    {
                      console.log('Cancelled - Submit delivery was not saved. May re-enter cores if needed');
                    } 
                  }
                  else
                  {
                    if(corePickupState['LOC'] === undefined || corePickupState['LOC'] === '0' || corePickupState['LOC'] === '999' || corePickupState['LOC'] === ''){
                      alert('Please enter a core loc.')
                    }  
                    else{
                      if (window.confirm('Click Ok to submit confirmation or Cancel to not submit confirmation.')) 
                      {
                        if(checkCorePickUpState === true) 
                        {
                          corePickupState['DETERMINED_CORE_CUSTID'] = clickedInvnoState.CUSTID
                          corePickupState['USERID'] = authreducerState.user.userid
                          
                          if(corePickupState['LOC'] === undefined || corePickupState['LOC'] === '0'){
                            corePickupState['LOC'] = clickedInvnoState.LOC
                          } 
                        }
                        console.log('Invoices corePickupState submit:' + JSON.stringify(corePickupState) + " Object.keys(corePickupState).length: " + Object.keys(corePickupState).length );
                        console.log('Invoices submit rotatesState:', rotatesState);
        
                        fetch_submitInvnoConfirmation(authreducerState.user, clickedInvnoState.INVNO,corePickupState, clickedInvnoState.CUSTID, returnsCommentState, invnoDeliveryDateState)

                        window.scrollTo({ top: 0, behavior: 'smooth' });        
                        
                        if( (invoiceErrorMessageState !== undefined && invoiceErrorMessageState !== null && invoiceErrorMessageState.length > 0 ) || 
                            (printConfirmationResponseState !== undefined && printConfirmationResponseState !== null && printConfirmationResponseState.length > 0)){
                          dispatch_setRowsDataSelectedIndexState([])
                          fetch_invoices(authreducerState.user)     
                          setIsDialogOpen(false);
                        }


                      } 
                      else 
                      {
                        console.log('Cancelled - Order was not saved.');
                      }  
                    }
                          
                  }    
              

                }
              }>
                Submit Confirmation
              </Button>
            </DialogActions>       
          </Dialog>
        </>
      : ''
    )

  }


  const ClearSelectedCheckboxButton = (selectedRows, displayData, setSelectedRows) => (
    <Tooltip title="Clear Selected Checkboxes">
      <IconButton id="clearPrintSelectedCbId" onClick={ () => {
        // console.log('ClearSelectedCheckboxButton clicked selectedRows: ' + JSON.stringify(selectedRows.selectedRows))

        dispatch_setRowsDataSelectedIndexState([])
        }
      }>Clear Selected Checkboxes</IconButton>
    </Tooltip>
  );

  const PrintButton = () => (
    <Tooltip title="Print Selected Invoices">
      <span>
        <IconButton id='printInvoicesBtnId' onClick={ () => {
            fetch_InvoicesPrintDetail(selectedInvnosState);
        }
        }><Print/> Print Selected Invoices</IconButton>
      </span>
    </Tooltip>
  );

  


  return (

    <div>
        <div>  
          <div>
            { invoiceErrorMessageState !== undefined && invoiceErrorMessageState !== null && invoiceErrorMessageState.length > 0 ? 
                <Alert variant="filled" severity="error">
                  { invoiceErrorMessageState }
                </Alert>
               : ''
            }            
            { invoiceNoticeMessageState !== undefined && invoiceNoticeMessageState !== null && invoiceNoticeMessageState.length > 0 ? 
                <Alert variant="filled" severity="warning">
                  { invoiceNoticeMessageState }
                </Alert>
               : ''
            }                            
            { printConfirmationResponseState !== undefined && printConfirmationResponseState !== null && printConfirmationResponseState.length > 0 ? 
              <Alert variant="filled" severity="success">
                { printConfirmationResponseState }
              </Alert>
              : ''
            }
            
          </div>


          <div>
            <button onClick={ () => {
              dispatch_setRowsDataSelectedIndexState([])
              fetch_invoices(authreducerState.user) 
            }}>Refresh Invoices Page</button>
          </div>
          
          <div id='invoiceTblId' className=''>

            { invoicesState !== undefined && invoicesState !== null ?
                invoicesState.length === 0 ?
                  <div>
                      <EmptyMuiDataTable title={'No Invoices'} />                  
                  </div>
                  : 
                  <div>  
                 
                    <MUIDataTable
                        title={"Invoices"}
                        data={invoicesState}
                        columns={columnsInvoices}
                        options={optionInvoices}
                    />  
                  </div>

              : ''            
            }

          </div>

          <div id='invoicePrintTblId' className=''>
            { printBtnClickedState !== undefined && printBtnClickedState !== null ?
                printBtnClickedState === false ?
                  <div>
                                    
                  </div>
                  : 
                  <div>
                    {/* {console.log('Invoices invoicePrintTblId rowsDataSelectedIndexState: ' + JSON.stringify(rowsDataSelectedIndexState))} */}
                    
                    {
                      <span style={{ display: "none",}}> 
                        <span ref={componentRef}>
                          <InvoicesPrintPage/>
                        </span>
                      </span>                                           
                    }
                  </div>

              : ''            
            }

          </div>

          <ConfirmDeliveryDialog/>

        </div>
    </div>

  );
}



const mapStateToProps = (state) => {
 return {
  authreducerState: state.authreducer,
  invoicesState: state.invoicesReducer['items_fetchInvoices'],
  invoicesPrintDetailState: state.invoicesReducer['items_fetchInvoicesPrint'],
  invoicesProcessingPrintedStatus: state.invoicesReducer['items_fetchInvoicesProcessingPrintedStatus'],
  rowsDataSelectedIndexState: state.invoicesReducer['items_rowsDataSelectedIndexState'],
  printConfirmationResponseState: state.invoicesReducer['items_printConfirmationResponseState'],
  invoiceErrorMessageState: state.invoicesReducer['items_invoiceErrorMessageState'],
  invoiceNoticeMessageState: state.invoicesReducer['items_invoiceNoticeMessageState'],
  noRotatesNeededCbState: state.rotatesReducer['noRotatesNeededCbState'],

  noReturnsNeededCbState: state.returnsReducer['noReturnsNeededCbState'],

  custnoDetailState: state.customersReducer['items_fetchCustnoDetail'],
  corePickupState: state.customersReducer['items_fetchCorePickup'],  
  custServerResponseState: state.statusUpdateReducer['custServerResponse'],    

 }
};

const mapDispatchToProps = (dispatch) => {
  return {      
    fetch_invoices: (user) => {
      dispatch(fetchInvoices(user));
    },
    fetch_InvoicesPrintDetail: (invoices) => {
      dispatch(fetchInvoicesPrintDetail(invoices));
    },     
    fetch_InvoicesPrintDetailReset: () => {   //CHECK IF NEEDED
      dispatch(fetchInvoicesPrintDetailReset());
    }, 
    fetch_InvoicesPrintRecordPrinted: (user, invoices) => {
      dispatch(fetchInvoicesPrintRecordPrinted(user, invoices));
    }, 
    dispatch_setRowsDataSelectedIndexState: (rowsSelected) => {
      dispatch(setRowsDataSelectedIndexState(rowsSelected));
    },
    dispatch_clearInvnoConfirmationStatus: () => {
      dispatch(clearInvnoConfirmationStatus());
    },

    fetch_rotatesInvno: (invno) => {
      dispatch(fetchRotatesInvno(invno));
    },     

    fetch_custnoDetail: (user, custid, searchCustno='') => {
      dispatch(fetchCustnoDetail(user, custid, searchCustno));
    }, 

    fetch_submitInvnoConfirmation: (user, custnoDetailState,corePickupState,custid, returnsCommentState, invnoDeliveryDateState) => {
      dispatch(fetchSubmitInvnoConfirmation(user, custnoDetailState,corePickupState,custid, returnsCommentState, invnoDeliveryDateState));

    },    
    fetch_customerDetailReset: () => {
      dispatch(fetchCustomerDetailReset());
    },        
    dispatchSetRotateRequestState: (row) => {
      dispatch(setRotateRequestState(row));
    },
    dispatchSetCorePickupState: (row) => {
      dispatch(setCorePickupState(row));
    },    
    dispatchSetNoRotatesNeededCbState: (result) => {
      dispatch(setNoRotatesNeededCbState(result));
    },      
    
    dispatchSetReturnsState: (returnsData) => {
      dispatch(setReturnsState(returnsData));
    },
    
    dispatchSetNoReturnsNeededCbState: (result) => {
      dispatch(setNoReturnsNeededCbState(result));
    },  

    fetch_InventoryDetailPartnos: (user, loc) => {
      dispatch(fetchInventoryDetailPartnos(user, loc));
    }    
    // set_rotatesState: (row) => {
    //   dispatch(setRotatesState(row));
    // }    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Invoices);